import ceramic1Thumb from '../images/previews/ceramics/0f514756-be46-4601-9455-ade990cf952e-thumb.webp';
import ceramic2Thumb from '../images/previews/ceramics/5b04fe91-2549-4a3d-80cf-74dd49a9091f-thumb.webp';
import ceramic3Thumb from '../images/previews/ceramics/8bdd0694-c180-44d8-8b7d-a9cd2daff0d2-thumb.webp';
import ceramic4Thumb from '../images/previews/ceramics/d4e9410c-b0e3-4992-9138-4f3e858f7564-thumb.webp';
import ceramic5Thumb from '../images/previews/ceramics/img-3033-thumb.webp';
import ceramic6Thumb from '../images/previews/ceramics/img-3435-thumb.webp';
import ceramic7Thumb from '../images/previews/ceramics/img-3436-thumb.webp';
import ceramic8Thumb from '../images/previews/ceramics/img-3437-thumb.webp';
import ceramic9Thumb from '../images/previews/ceramics/img-3440-thumb.webp';
import ceramic10Thumb from '../images/previews/ceramics/img-3669-thumb.webp';

import albumCoverThumb from '../images/previews/digital_art/album-cover-thumb.webp';
import alternateThumb from '../images/previews/digital_art/alternate-thumb.webp';
import buddhaThumb from '../images/previews/digital_art/buddha-thumb.webp';
import cagedThumb from '../images/previews/digital_art/caged-thumb.webp';
import digitalFormThumb from '../images/previews/digital_art/digitalform-thumb.webp';
import eleganzThumb from '../images/previews/digital_art/eleganz-thumb.webp';
import faceThumb from '../images/previews/digital_art/face-thumb.webp';
import finalishThumb from '../images/previews/digital_art/finalish-thumb.webp';
import finish1Thumb from '../images/previews/digital_art/finish1-thumb.webp';
import flameThumb from '../images/previews/digital_art/flame-thumb.webp';
import fluidLegsThumb from '../images/previews/digital_art/fluid-legs-thumb.webp';
import fwazoomThumb from '../images/previews/digital_art/fwazoom-thumb.webp';
import goopeyDropeyThumb from '../images/previews/digital_art/goopey-droopey-thumb.webp';
import headerThumb from '../images/previews/digital_art/header-thumb.webp';
import insightThumb from '../images/previews/digital_art/insight-thumb.webp';
import manWingsThumb from '../images/previews/digital_art/man-wings-thumb.webp';
import manWingsVideoThumb from '../images/previews/digital_art/man-wings-video-thumb.webp';
import moonBoomThumb from '../images/previews/digital_art/moon-boom-thumb.webp';
import mwxPosterThumb from '../images/previews/digital_art/mwx-poster-final-thumb.webp';
import obeliskThumb from '../images/previews/digital_art/obelisk-thumb.webp';
import particularMattersThumb from '../images/previews/digital_art/particular-matters-thumb.webp';
import philosopherThumb from '../images/previews/digital_art/phil0s0pher-thumb.webp';
import photoAug1Thumb from '../images/previews/digital_art/photo-aug-12-5-00-05-pm-thumb.webp';
import photoAug2Thumb from '../images/previews/digital_art/photo-aug-12-5-00-23-pm-thumb.webp';
import posterThumb from '../images/previews/digital_art/poster-thumb.webp';
import quickieThumb from '../images/previews/digital_art/quickie-thumb.webp';
import ripuhThumb from '../images/previews/digital_art/ripuh-thumb.webp';
import room2Thumb from '../images/previews/digital_art/room2-thumb.webp';
import scallopsFrontThumb from '../images/previews/digital_art/scallops-front-thumb.webp';
import shapeFormThumb from '../images/previews/digital_art/shape-form-thumb.webp';
import shinyBloobThumb from '../images/previews/digital_art/shinybloob-thumb.webp';
import spacemanThumb from '../images/previews/digital_art/spaceman-thumb.webp';
import spinFinThumb from '../images/previews/digital_art/spin-fin-thumb.webp';
import theEmpressThumb from '../images/previews/digital_art/the-empress-thumb.webp';
import theHighPriestessThumb from '../images/previews/digital_art/the-high-priestess-notcard-thumb.webp';
import ticket3Thumb from '../images/previews/digital_art/ticket-3-thumb.webp';
import trumpThumb from '../images/previews/digital_art/trump-thumb.webp';
import untitledThumb from '../images/previews/digital_art/untitled-thumb.webp';
import colorShapeFluidThumb from '../images/previews/digital_art/color-shape-fluid-thumb.webp';

import badboyThumb from '../images/previews/music/badboy-thumb.webp';
import goodboyThumb from '../images/previews/music/good-boy-thumb.webp';
import finalVoyageThumb from '../images/previews/music/thefinalvoyageofthelastking-thumb.webp';
import lastHumanThumb from '../images/previews/music/thelasthumanwillbeakinginspace-thumb.webp';

import physicalArt1Thumb from '../images/previews/physical_art/000-thumb.webp';

import storePot01Thumb from '../images/previews/store/dsc-0001-thumb.webp';
import storePot04Thumb from '../images/previews/store/dsc-0004-thumb.webp';
import storePot06Thumb from '../images/previews/store/dsc-0006-thumb.webp';
import storePot07Thumb from '../images/previews/store/dsc-0007-thumb.webp';
import storePot08Thumb from '../images/previews/store/dsc-0008-thumb.webp';
import storePot09Thumb from '../images/previews/store/dsc-0009-thumb.webp';
import storePot10Thumb from '../images/previews/store/dsc-0010-thumb.webp';
import storePot11Thumb from '../images/previews/store/dsc-0011-thumb.webp';
import storePot12Thumb from '../images/previews/store/dsc-0012-thumb.webp';
import storePot14Thumb from '../images/previews/store/dsc-0014-thumb.webp';
import storePot15Thumb from '../images/previews/store/dsc-0015-thumb.webp';
import storePot16Thumb from '../images/previews/store/dsc-0016-thumb.webp';
import storePot17Thumb from '../images/previews/store/dsc-0017-thumb.webp';
import storePot18Thumb from '../images/previews/store/dsc-0018-thumb.webp';
import storePot19Thumb from '../images/previews/store/dsc-0019-thumb.webp';
import storePot20Thumb from '../images/previews/store/dsc-0020-thumb.webp';
import storePot21Thumb from '../images/previews/store/dsc-0021-thumb.webp';
import storePot22Thumb from '../images/previews/store/dsc-0022-thumb.webp';
import storePot23Thumb from '../images/previews/store/dsc-0023-thumb.webp';
import storePot24Thumb from '../images/previews/store/dsc-0024-thumb.webp';
import storePot25Thumb from '../images/previews/store/dsc-0025-thumb.webp';
import storePot26Thumb from '../images/previews/store/dsc-0026-thumb.webp';
import storePot27Thumb from '../images/previews/store/dsc-0027-thumb.webp';
import storePot28Thumb from '../images/previews/store/dsc-0028-thumb.webp';

export const ceramicPreviews = {
  img1: ceramic1Thumb,
  img2: ceramic2Thumb,
  img3: ceramic3Thumb,
  img4: ceramic4Thumb,
  img5: ceramic5Thumb,
  img6: ceramic6Thumb,
  img7: ceramic7Thumb,
  img8: ceramic8Thumb,
  img9: ceramic9Thumb,
  img10: ceramic10Thumb
};

export const digitalArtPreviews = {
  albumCover: albumCoverThumb,
  alternate: alternateThumb,
  buddha: buddhaThumb,
  caged: cagedThumb,
  digitalForm: digitalFormThumb,
  eleganz: eleganzThumb,
  face: faceThumb,
  finalish: finalishThumb,
  finish1: finish1Thumb,
  flame: flameThumb,
  fluidLegs: fluidLegsThumb,
  fwazoom: fwazoomThumb,
  goopeyDropey: goopeyDropeyThumb,
  header: headerThumb,
  insight: insightThumb,
  manWings: manWingsThumb,
  manWingsVideo: manWingsVideoThumb,
  moonBoom: moonBoomThumb,
  mwxPoster: mwxPosterThumb,
  obelisk: obeliskThumb,
  particularMatters: particularMattersThumb,
  philosopher: philosopherThumb,
  photoAug1: photoAug1Thumb,
  photoAug2: photoAug2Thumb,
  poster: posterThumb,
  quickie: quickieThumb,
  ripuh: ripuhThumb,
  room2: room2Thumb,
  scallopsFront: scallopsFrontThumb,
  shapeForm: shapeFormThumb,
  shinyBloob: shinyBloobThumb,
  spaceman: spacemanThumb,
  spinFin: spinFinThumb,
  theEmpress: theEmpressThumb,
  theHighPriestess: theHighPriestessThumb,
  ticket3: ticket3Thumb,
  trump: trumpThumb,
  untitled: untitledThumb,
  colorShapeFluid: colorShapeFluidThumb
};

export const musicPreviews = {
  badboy: badboyThumb,
  goodboy: goodboyThumb,
  finalVoyage: finalVoyageThumb,
  lastHuman: lastHumanThumb
};

export const physicalArtPreviews = {
  physicalArt1: physicalArt1Thumb
};

export const storePreviews = {
  pot01: storePot01Thumb,
  pot04: storePot04Thumb,
  pot06: storePot06Thumb,
  pot07: storePot07Thumb,
  pot08: storePot08Thumb,
  pot09: storePot09Thumb,
  pot10: storePot10Thumb,
  pot11: storePot11Thumb,
  pot12: storePot12Thumb,
  pot14: storePot14Thumb,
  pot15: storePot15Thumb,
  pot16: storePot16Thumb,
  pot17: storePot17Thumb,
  pot18: storePot18Thumb,
  pot19: storePot19Thumb,
  pot20: storePot20Thumb,
  pot21: storePot21Thumb,
  pot22: storePot22Thumb,
  pot23: storePot23Thumb,
  pot24: storePot24Thumb,
  pot25: storePot25Thumb,
  pot26: storePot26Thumb,
  pot27: storePot27Thumb,
  pot28: storePot28Thumb
};
